import {
  extractPreciseXrefs,
  scrollToXrefByKey,
} from "../Utility/FrontMatterList";
import CustomModel from "../Utility/CustomModel";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

const CitationtoSupScript = ({ visible, editor, editRef, onClose }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [xrefs, setXrefs] = useState([]);
  const buttonWrapperRef = useRef(null);

  const handleCheckboxChange = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleNumberClick = (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToXrefByKey(editRef, key);
  };

  const handleSubmit = () => {
    if (!editor || !selectedKeys.length) return;

    const dom = editor.dom;
    const main = dom.select("body1")[0];

    selectedKeys.forEach((key) => {
      const xref = main.querySelector(`xref[key="${key}"]`);
      if (xref) {
        const parent = xref.parentNode;
        const prev = xref.previousSibling;
        const next = xref.nextSibling;

        // Remove leading bracket like " ["
        if (prev && prev.nodeType === 3 && /\[\s*$/.test(prev.textContent)) {
          prev.textContent = prev.textContent.replace(/\[\s*$/, "");
        }

        // Remove trailing bracket like "] "
        if (next && next.nodeType === 3 && /^\s*\]/.test(next.textContent)) {
          next.textContent = next.textContent.replace(/^\s*\]/, "");
        }

        // Set xref content and apply superscript styling
        const number = xref.textContent.trim();
        dom.setHTML(xref, number);
        dom.setStyles(xref, {
          verticalAlign: "super",
          fontSize: "medium",
          cursor: "pointer",
          padding: "0 5px 0 0",
        });
      }
    });
    toast.success("Citations Changed");
    onClose(); // Optional
  };

  useEffect(() => {
    if (editor) {
      const response = extractPreciseXrefs(editor);
      setXrefs(response);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!editor) return;
      if (!buttonWrapperRef.current) return;
      const clickedInsideAnyXrefBox = buttonWrapperRef.current.contains(
        event.target
      );

      if (!clickedInsideAnyXrefBox) {
        const highlighted = editor.dom.select("xref.highlighted-xref");
        if (highlighted.length > 0) {
          editor.dom.removeClass(highlighted, "highlighted-xref");
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <CustomModel
      handleCancel={onClose}
      heading={"Citations To superScript"}
      width={"30%"}
      show={visible}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        {/* Scrollable content inside form */}
        <div className="space-y-3">
          {/* <div className="flex w-full items-center justify-between border-b pb-2  mt-2">
            <h3 className="text-[16px] font-semibold">
              Citations To SuperScript
            </h3> */}
            <div className="flex items-center gap-2  px-4  mt-2 justify-end">
              <span className="font-semibold text-md">Select All</span>
              <input
                type="checkbox"
                className="w-[20px] h-[18px] cursor-pointer"
                checked={
                  selectedKeys.length === xrefs.length && xrefs.length > 0
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys(xrefs.map((x) => x.key));
                  } else {
                    setSelectedKeys([]);
                  }
                }}
              />
            </div>
          {/* </div> */}
          {/* Xrefs List */}
          <div className="max-h-[400px] min-h-200px overflow-y-auto space-y-3">
            {xrefs.length > 0 ? (
              xrefs.map((xref, index) => (
                <div
                  ref={buttonWrapperRef}
                  key={xref.key}
                  className="flex justify-between items-center border p-2 rounded hover:bg-gray-50"
                >
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      className="cursor-pointer"
                      checked={selectedKeys.includes(xref.key)}
                      onChange={() => handleCheckboxChange(xref.key)}
                    />
                    <span className="px-4">
                      {
                        xref.beforeText.length > 120
                          ? `${xref.beforeText
                              .replace(/^[\]\[.\s]+/, "") // clean start
                              .replace(/[\]\[.\s]+$/, "") // clean end
                              .slice(0, 120)}...`
                          : xref.beforeText
                              .replace(/^[\]\[.\s]+/, "") // clean start
                              .replace(/[\]\[.\s]+$/, "") // clean end
                      }
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => handleNumberClick(e, xref.key)}
                    className="text-blue-600 hover:underline min-w-[70px]"
                  >
                    [{xref.number}]
                  </button>
                </div>
              ))
            ) : (
              <>
                <h4 className="text-center text-[18px] w-full mb-5 ">
                  No Citations Available
                </h4>
              </>
            )}
          </div>
        </div>

        {/* ✅ Footer: Submit and Cancel */}
        <div className="flex justify-end gap-4  pt-4 px-2">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-200 px-4 py-[4px] rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-[4px] rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </form>
    </CustomModel>
  );
};

export default CitationtoSupScript;
